import { cx } from "../../lib/cx.js";
/* empty css              */
import { jsx } from "react/jsx-runtime";
//#region src/components/FormField/FieldGroup.tsx
/**
* Form fields `--field-group-gap` apart (20px; 24px in LEADSPPLY): a form, a modal's
* fields, or a row of short fields.
*/
function FieldGroup({ as: Element = "div", layout = "stack", className, ...rest }) {
	return /* @__PURE__ */ jsx(Element, {
		...rest,
		className: cx("ds-field-group", layout === "row" && "ds-field-group--row", className)
	});
}
//#endregion
export { FieldGroup };

//# sourceMappingURL=FieldGroup.js.map